module.exports = __webpack_public_path__ + "img/kebs.38a600f0.jpg";